export default __webpack_public_path__ + "static/media/philosophyImg.fa23fc6f.png";